import { createFileRoute } from '@tanstack/react-router'
import MarketingSegmentosPage from '@/pages/dashboard/marketing-segmentos-page'
import { RequireModule } from '@/components/auth'
import { MODULES } from '@/constants/modules'

export const Route = createFileRoute(
  '/(dashboard)/dashboard/$dashboardId/marketing/segmentos',
)({
  component: function MarketingSegmentosRoute() {
    const { dashboardId } = Route.useParams()

    return (
      <RequireModule module={MODULES.MARKETING} dashboardId={dashboardId}>
        <MarketingSegmentosPage />
      </RequireModule>
    )
  },
})
